import { Component, ReactNode } from 'react'
import { connect } from 'react-redux'

import { store } from './redux/store'

import { MY_DATA_URL } from './confs/costants'

import { 
    UserType,
    Status,
    ComponentStatus, componentStatusUpdate, emptyComponentStatus 
} from './slices/LoginSlice'

import LoginDropDown from './components/drop_down/LoginDropDown'
import LogoutDropDown from './components/drop_down/LogoutDropDown'


import { deleteToken, getToken } from './utils/manageToken'

import './App.scss'


interface Props {}

type AppStatus = ComponentStatus

class App  extends Component<Props,AppStatus> {

	constructor (props: any) {
		super(props)

        this.state = {
            ...emptyComponentStatus,
            ...props
        }

        this.updateUser = this.updateUser.bind(this)

        this.getStorableStatus = this.getStorableStatus.bind(this)
        this.autoLogin = this.autoLogin.bind(this)
	}

    componentDidMount(): void {
        const token = getToken()

        if (token !== undefined) {
            this.autoLogin( token )
        }
        else {
            this.updateUser( undefined )
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<ComponentStatus>, snapshot?: any): void {
        if (
            (this.state.user === undefined && prevState.user?.id !== undefined) ||
            (this.state.user?.id !== undefined && prevState.user === undefined)
        ) {
            console.log ("reload()")
            setTimeout( () => {
                window.location.reload()
            }, 300) 
        }
    }

	render(): ReactNode {
		return (
			<div className="login-container">
      
				{ this.state.user === undefined &&
                    <LoginDropDown 
                        updateUserCallBack = { this.updateUser }
                    />
                }
                { this.state.user !== undefined &&
                    <LogoutDropDown 
                        user = { this.state.user }
                        updateUserCallBack = { this.updateUser }
                    />
                }

    		</div>
		)
	}


    private updateUser (u: UserType | undefined) {
        this.setState({
            user: u
        }, () => {

            if (u === undefined) {
                deleteToken()
            }

            store.dispatch ( componentStatusUpdate( this.getStorableStatus() ) )

        })
    }

    private getStorableStatus () : Status {
        // nella risposta dello user service .. c è qualcosa di non serializzabile!
        return {
            user: {
                id: this.state.user?.id,
                name: this.state.user?.name,
                surname: this.state.user?.surname,
                email: this.state.user?.email,
                phone: this.state.user?.phone,
                sf_account_id: this.state.user?.sf_account_id,
            }
        }
    }

    private autoLogin (token: string) {
        const requestHeaders: HeadersInit = new Headers()
        requestHeaders.append('Origin', 'https://www.6sicuro.it')
        requestHeaders.append('Referer', 'https://www.6sicuro.it/')
        requestHeaders.append('Content-Type', 'application/json; charset="utf-8"')
        requestHeaders.append('Authorization', `Bearer ${token}`)


        fetch (
            MY_DATA_URL,
            {
                method: "GET",
                headers: requestHeaders
            }
        )
        .then ( (response) => {

            if (!response.ok) {
                let err = new Error("HTTP status code: " + response.status)
                throw err
            }

            return response.json()
        })
        .then ( (userJson: UserType) => {

            // response OK
            this.updateUser( userJson )

        })
        .catch ( () => {
            
            this.updateUser( undefined )

        })
    }
}


const mapState = (state: any) => {
	return {
		user: (state.user?.id) ? state.user : undefined
	}
}
  
export default connect(mapState) (App)
